import type { ErrorEvent } from '@sentry/core';

// Timeout / network errors are environmental noise (lost connectivity, slow
// networks) rather than app bugs. They are especially common on mobile web
// views, where they are driven by the device's connectivity rather than
// anything we can fix, so they are not actionable individually. They are
// excluded from session replays and dropped before being sent to Sentry.
export const ENVIRONMENTAL_ERROR_PATTERNS = [
  /network error/i,
  /err_network/i,
  /timeout/i,
  /timed out/i,
  /econnaborted/i,
  /econnreset/i,
  /etimedout/i,
];

export function isEnvironmentalError(event: ErrorEvent): boolean {
  const exceptions = event.exception?.values;
  if (!exceptions) {
    return false;
  }

  return exceptions.some((exception) => {
    const text = [exception.type, exception.value].filter(Boolean).join(' ');
    return ENVIRONMENTAL_ERROR_PATTERNS.some((pattern) => pattern.test(text));
  });
}
